<template>
  <el-dialog
    :modal-append-to-body="false"
    :visible.sync="visible"
    :title="$t('Integrations_ActiveDirectory_SyncUsersDialog_Title')"
    width="400px"
    center
  >
    <rest-form
      :model="taskModel"
      :save-endpoint="saveEndpoint"
      :success-message="
        $t('Integrations_ActiveDirectory_SyncUsersDialog_SuccessMessage')
      "
      :rules="rules"
      ref="form"
    >
      <el-row>
        <rest-form-item
          prop="params.mirror_sync"
          :hint="$t('Integrations_ActiveDirectory_Text_MirrorSyncWarning')"
        >
          <el-switch
            v-model="taskModel.mirror_sync"
            :active-text="$t('Integrations_ActiveDirectory_Field_MirrorSync')"
          />
        </rest-form-item>
      </el-row>

      <el-row>
        <rest-form-item
          prop="whitelist_users"
          :hint="
            $t('Integrations_ActiveDirectory_Field_WhitelistUsers_Description')
          "
        >
          <el-switch
            v-model="taskModel.whitelist_users"
            :active-text="
              $t('Integrations_ActiveDirectory_Field_WhitelistUsers')
            "
          />
        </rest-form-item>

        <rest-form-item
          v-if="taskModel.whitelist_users"
          prop="whitelisted_users"
          :hint="
            $t(
              'Integrations_ActiveDirectory_Field_WhitelistedUsers_Description'
            )
          "
        >
          <el-input
            type="textarea"
            v-model="taskModel.whitelisted_users"
            :rows="6"
          ></el-input>
        </rest-form-item>
      </el-row>

      <el-row type="flex" justify="center">
        <el-button type="primary" @click="save">
          {{ $t('Integrations_ActiveDirectory_SyncUsersDialog_StartSync') }}
        </el-button>
      </el-row>
    </rest-form>
  </el-dialog>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'ActiveDirectorySyncUsersDialog',

  components: { RestFormItem, RestForm },

  data() {
    return {
      visible: false,
      taskModel: {}
    }
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `integrations/active-directory/${this.model.id}/sync-users`
      })
    },

    rules() {
      return {
        daterange: {
          required: true
        }
      }
    }
  },

  methods: {
    show() {
      this.taskModel = {
        mirror_sync: this.model.params.mirror_sync,
        whitelist_users: this.model.params.whitelist_users,
        whitelisted_users: this.model.params.whitelisted_users
      }

      this.visible = true
    },

    save() {
      this.$refs['form'].save().then(taskRecord => {
        this.$router.push(
          projectRoute({
            name: 'TaskHistoryView',
            query: { id: taskRecord.id }
          })
        )
      })
    }
  }
}
</script>

<style scoped>
>>> .el-row {
  margin-bottom: 20px;
  word-break: break-word;
}

>>> .el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/activedirectory/ActiveDirectorySyncUsersDialog.vue